import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import activeMenu from './modules/activeMenu'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    activeMenu,
  },
})

export default store
